var _defs, _rect, _image, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventType1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Banner_Layout_3b",
    "data-name": "Banner Layout 3b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 1080",
    height: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8 {\n        fill: #dfebeb;\n      }\n\n      .cls-9 {\n        font-size: 60px;\n      }\n\n      .cls-9, .cls-10, .cls-11 {\n        fill: #dbeaea;\n      }\n\n      .cls-9, .cls-11, .cls-6 {\n        isolation: isolate;\n      }\n\n      .cls-9, .cls-6 {\n        font-family: Roboto-Medium, Roboto;\n        font-weight: 500;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-2);\n        opacity: .78;\n      }\n\n      .cls-11 {\n        font-family: Roboto-Bold, Roboto;\n        font-size: 94px;\n        font-weight: 700;\n      }\n\n      .cls-6 {\n        font-size: 47.3059px;\n      }\n\n      .cls-20 {\n        fill: #00c8ea;\n      }\n\n      .cls-21 {\n        letter-spacing: .0244em;\n      }\n\n      .cls-7 {\n        filter: url(#drop-shadow-1);\n      }\n\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 842.5579,
    y1: -126.0474,
    x2: 1083.5076,
    y2: 1240.4463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#022544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    stopColor: "#437594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 838.707,
    y1: -147.8867,
    x2: 1081.293,
    y2: 1227.8867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0575,
    stopColor: "#011328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2758,
    stopColor: "#051a33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6228,
    stopColor: "#0a213e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c2442"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    x: 143.8456,
    y: 389.3753,
    width: 1400,
    height: 600,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "BACKGROUND",
    className: "cls-4",
    width: 1920,
    height: 1080
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "REPLACE_ME",
    "data-name": "REPLACE ME",
    width: 1920,
    height: 1080,
    xlinkHref: "default.png"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "OVERLAY",
    className: "cls-12",
    width: 1920,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "DATE",
    className: "cls-6",
    transform: "translate(236.6092 698.7398)"
  }, "Date"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "EVENT_TITLE",
    "data-name": "EVENT TITLE",
    className: "cls-11",
    transform: "translate(156.934 482.8251)"
  }, "Title"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "LOCATION_1",
    "data-name": "LOCATION 1",
    className: "cls-6",
    transform: "translate(237.6478 798.0106)"
  }, "Location 1"), /*#__PURE__*/React.createElement("text", {
    id: "LOCATION_2",
    "data-name": "LOCATION 2",
    className: "cls-6",
    transform: "translate(237.6478 872.1717)"
  }, "Location 2"), /*#__PURE__*/React.createElement("text", {
    id: "LOCATION_3",
    "data-name": "LOCATION 3",
    className: "cls-6",
    transform: "translate(237.6478 946.3328)"
  }, "Location 3"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SUBTITLE",
    className: "cls-9",
    transform: "translate(156.9344 575.64)"
  }, "Subtitle"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "TimeContainer",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "CLOCK",
    className: "cls-5",
    d: "M576.383,656.1616c-13.7132,0-24.8179,11.1295-24.8179,24.8427s11.1047,24.8427,24.8179,24.8427c13.738,0,24.8676-11.1295,24.8676-24.8427s-11.1295-24.8427-24.8676-24.8427ZM586.345,690.9415c-.9689.9689-2.534.9689-3.5028,0l-8.1733-8.1733c-.472-.472-.7453-1.0931-.7453-1.7638v-9.9371c0-1.3664,1.1179-2.4843,2.4843-2.4843h0c1.3664,0,2.4843,1.1179,2.4843,2.4843v8.9185l7.4528,7.4528c.9689.9689.9689,2.534,0,3.5028Z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TIME",
    className: "cls-6",
    transform: "translate(631.9376 698.2113)"
  }, "Time"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "CALENDAR",
    className: "cls-5",
    d: "M199.8057,659.5689h-2.6794v-5.3589h-5.3589v5.3589h-21.4354v-5.3589h-5.3589v5.3589h-2.6794c-2.9742,0-5.3321,2.4115-5.3321,5.3589l-.0268,37.512c0,2.9474,2.3847,5.3589,5.3589,5.3589h37.512c2.9474,0,5.3589-2.4115,5.3589-5.3589v-37.512c0-2.9474-2.4115-5.3589-5.3589-5.3589ZM199.8057,702.4398h-37.512v-26.7943h37.512v26.7943ZM173.0115,686.3632h-5.3589v-5.3589h5.3589v5.3589ZM183.7292,686.3632h-5.3589v-5.3589h5.3589v5.3589ZM194.4469,686.3632h-5.3589v-5.3589h5.3589v5.3589ZM173.0115,697.0809h-5.3589v-5.3589h5.3589v5.3589ZM183.7292,697.0809h-5.3589v-5.3589h5.3589v5.3589ZM194.4469,697.0809h-5.3589v-5.3589h5.3589v5.3589Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "LOCATION_1-2",
    "data-name": "LOCATION 1",
    className: "cls-7",
    d: "M181.0497,754.0775c-11.0121,0-19.9185,8.9064-19.9185,19.9185,0,14.9389,19.9185,36.9916,19.9185,36.9916,0,0,19.9185-22.0527,19.9185-36.9916,0-11.0121-8.9064-19.9185-19.9185-19.9185ZM181.0497,781.1098c-3.9268,0-7.1138-3.187-7.1138-7.1138s3.187-7.1138,7.1138-7.1138,7.1138,3.187,7.1138,7.1138-3.187,7.1138-7.1138,7.1138Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "LOCATION_2-2",
    "data-name": "LOCATION 2",
    className: "cls-7",
    d: "M181.0497,828.2386c-11.0121,0-19.9185,8.9064-19.9185,19.9185,0,14.9389,19.9185,36.9916,19.9185,36.9916,0,0,19.9185-22.0527,19.9185-36.9916,0-11.0121-8.9064-19.9185-19.9185-19.9185ZM181.0497,855.2709c-3.9268,0-7.1138-3.187-7.1138-7.1138s3.187-7.1138,7.1138-7.1138,7.1138,3.187,7.1138,7.1138-3.187,7.1138-7.1138,7.1138Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "LOCATION_3-2",
    transform: "translate(0, 74.16)",
    "data-name": "LOCATION 2",
    className: "cls-7",
    d: "M181.0497,828.2386c-11.0121,0-19.9185,8.9064-19.9185,19.9185,0,14.9389,19.9185,36.9916,19.9185,36.9916,0,0,19.9185-22.0527,19.9185-36.9916,0-11.0121-8.9064-19.9185-19.9185-19.9185ZM181.0497,855.2709c-3.9268,0-7.1138-3.187-7.1138-7.1138s3.187-7.1138,7.1138-7.1138,7.1138,3.187,7.1138,7.1138-3.187,7.1138-7.1138,7.1138Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1478.9533,190.5785c-.4583-.4741-.9722-.8911-1.5305-1.2419-.7457-.4793-1.5313-.8934-2.3482-1.2375-.9549-.4055-1.9442-.7245-2.9561-.9533-1.0833-.2456-2.1907-.3689-3.3015-.3673-2.5013,0-4.3408.4577-5.5186,1.3731-1.1668.9065-1.8193,2.3242-1.7491,3.8-.0322.7854.1604,1.5637.5554,2.2433.4388.6432,1.029,1.1688,1.7185,1.5305.9184.5013,1.8931.8918,2.9036,1.1632,1.1588.3367,2.5144.6953,4.0668,1.0845,1.7441.4091,3.4626.9202,5.1469,1.5305,1.389.4879,2.6966,1.1822,3.8787,2.0596,1.0411.7883,1.8828,1.8097,2.4576,2.9823.6178,1.3482.9171,2.8205.8746,4.3029.0432,1.7002-.3275,3.3855-1.0801,4.9107-.6961,1.3443-1.7129,2.4963-2.9604,3.354-1.3284.8973-2.8108,1.5421-4.3729,1.9022-1.7464.4129-3.536.6155-5.3305.6035-2.8068.0008-5.5961-.442-8.2647-1.3119-2.6021-.8343-5.0402-2.1125-7.2065-3.7782l2.6806-5.0463c.6057.5754,1.2679,1.0882,1.9765,1.5305.9533.6122,1.962,1.1334,3.0129,1.5567,1.2079.4989,2.4519.9053,3.7213,1.2157,1.3645.3389,2.7657.5079,4.1717.5029,2.3322,0,4.128-.4052,5.3874-1.2157,1.2394-.7616,1.9665-2.137,1.8978-3.5901.0315-.8485-.2192-1.6836-.7128-2.3745-.5492-.696-1.2429-1.2645-2.0334-1.6661-1.0283-.5393-2.1061-.9786-3.2184-1.3119-1.2681-.3848-2.7112-.7886-4.3291-1.2113-1.6566-.4267-3.2875-.9479-4.8845-1.5611-1.254-.4637-2.4228-1.1316-3.4589-1.9765-.8872-.7355-1.5985-1.6605-2.0815-2.7068-.5065-1.1935-.7496-2.4822-.7128-3.7782-.0318-1.6864.329-3.3571,1.0539-4.8801.6823-1.3932,1.665-2.6178,2.8773-3.5857,1.2807-.9981,2.7416-1.7404,4.3029-2.1864,1.7508-.5044,3.5654-.7534,5.3874-.739,2.3953-.0239,4.7749.388,7.0228,1.2157,2.0134.7422,3.9146,1.7591,5.6497,3.0217l-2.6937,4.8364Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1487.1917,200.2425c.007-2.2987.4185-4.5782,1.2157-6.7342.7949-2.2139,2.0044-4.256,3.5639-6.0171,1.5993-1.8064,3.548-3.2702,5.7285-4.3029,2.3936-1.1241,5.0129-1.685,7.6569-1.6398,3.4108,0,6.3261.758,8.7457,2.2739,2.3447,1.4218,4.2467,3.4692,5.4923,5.9121l-4.6484,3.1135c-.4733-1.0473-1.1143-2.0103-1.8978-2.8511-.7023-.7459-1.524-1.3695-2.4313-1.8453-.8652-.4531-1.7895-.7828-2.7462-.9795-.9035-.1875-1.8234-.2842-2.7462-.2886-1.7967-.0424-3.5754.3665-5.1731,1.1894-1.4513.7675-2.7204,1.8383-3.7213,3.1397-1.0104,1.3112-1.7789,2.792-2.2695,4.3729-.5043,1.5703-.7638,3.2089-.7696,4.8582-.0097,1.7884.2952,3.5646.9008,5.2474.5685,1.595,1.417,3.0758,2.5056,4.3729,1.062,1.2566,2.3644,2.2884,3.8306,3.0348,1.5045.764,3.171,1.154,4.8583,1.1369.9519-.004,1.9001-.1199,2.8249-.3455.9805-.2347,1.9227-.6071,2.7986-1.1063.9124-.524,1.7469-1.1731,2.4794-1.9284.7851-.8153,1.4201-1.7627,1.876-2.7986l4.9107,2.7986c-.59,1.3965-1.4522,2.6616-2.5363,3.7213-1.095,1.079-2.3394,1.995-3.6951,2.7199-1.3825.7418-2.8512,1.3102-4.3729,1.6923-1.4762.3777-2.9934.5716-4.5172.5772-2.512.0312-4.994-.548-7.2327-1.6879-2.1451-1.0987-4.0622-2.5945-5.6497-4.4078-1.5891-1.8237-2.8404-3.916-3.6951-6.1789-.8591-2.2504-1.295-4.6402-1.2856-7.0491Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1536.7188,181.7628h5.1687l14.7803,37.4886h-6.2182l-3.9618-10.1931h-14.4698l-3.905,10.1931h-6.2838l14.8896-37.4886ZM1545.3246,204.6766l-6.0171-16.1053-6.2313,16.1053h12.2484Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1567.7661,192.848v26.4034h-5.9121v-37.4886h4.644l21.427,27.033v-26.9893h5.9996v37.4361h-4.9326l-21.2259-26.3946Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1602.8802,219.2513v-37.4886h13.3066c2.722-.0597,5.427.4435,7.9455,1.478,2.1604.9137,4.0991,2.2813,5.6847,4.0099,1.5499,1.7157,2.7289,3.7329,3.4633,5.9252.7857,2.3389,1.1788,4.7917,1.1632,7.259.0306,2.6364-.4138,5.2567-1.3119,7.7356-.7991,2.2054-2.0486,4.2203-3.6688,5.9165-1.6254,1.6624-3.5875,2.9581-5.7547,3.8-2.4087.9252-4.9719,1.3823-7.5519,1.3468l-13.276.0175ZM1628.4353,200.448c.0202-1.8439-.2559-3.6791-.8177-5.4355-.4971-1.5691-1.3146-3.018-2.4007-4.2548-1.0722-1.1886-2.3876-2.1326-3.8569-2.768-1.6349-.6938-3.3973-1.0364-5.1731-1.0058h-7.3945v27.033h7.3945c1.8022.0336,3.591-.3167,5.2474-1.0276,1.4831-.6492,2.8013-1.6236,3.8569-2.8511,1.0624-1.263,1.8609-2.7261,2.3482-4.3029.5429-1.7422.8114-3.5582.7959-5.383v-.0044Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1641.2128,219.2513v-37.4886h5.9165v37.4886h-5.9165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1662.0188,192.848v26.4034h-5.9165v-37.4886h4.6484l21.427,27.033v-26.9893h5.969v37.4361h-4.902l-21.2259-26.3946Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1708.1657,181.7628h5.1775l14.7803,37.4886h-6.227l-3.9618-10.1931h-14.4654l-3.9093,10.1931h-6.2838l14.8896-37.4886ZM1716.7715,204.6766l-6.0171-16.1053-6.2313,16.1053h12.2484Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1732.4569,181.7628l11.2995,30.0416,11.247-30.0416h6.2838l-14.9989,37.4886h-5.0681l-15.047-37.4886h6.2838Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1766.4078,219.2513v-37.4886h5.9296v37.4886h-5.9296Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1792.3302,181.7628h5.1775l14.7847,37.4886h-6.2313l-3.9618-10.1931h-14.4567l-3.9356,10.1931h-6.2663l14.8896-37.4886ZM1800.9403,204.6766l-6.0214-16.1053-6.2313,16.1053h12.2527Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1515.4667,108.5567l23.6135,56.4974,23.6135-56.4974h4.7227l-26.2372,62.0947h-4.1017l-26.3246-62.0947h4.7139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1591.0298,108.5567h3.8481l26.2372,62.0947h-4.7227l-8.6583-20.465h-29.648l-8.6495,20.465h-4.8102l26.4034-62.0947ZM1606.5097,146.5131l-13.5559-32.5341-13.8183,32.5341h27.3741Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1667.7298,112.5797h-22.7389v58.0716h-4.4603v-58.0716h-22.7389v-4.023h49.9381v4.023Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1713.3825,118.8766c-4.023-4.4924-9.7078-6.7371-17.0542-6.7342-6.0637,0-10.4803,1.1515-13.2498,3.4546-2.7695,2.303-4.1542,5.4078-4.1542,9.3142-.0604,1.7082.3,3.4051,1.0495,4.9413.7765,1.3925,1.9081,2.5543,3.2796,3.3671,1.7604,1.0475,3.6593,1.8424,5.641,2.3613,2.2739.6443,5.0142,1.3148,8.221,2.0115,3.3234.6997,6.3407,1.4722,9.0518,2.3176,2.4464.7215,4.774,1.7969,6.9091,3.1922,1.8179,1.1977,3.3183,2.8182,4.3729,4.7227,1.0174,1.8687,1.5276,4.1717,1.5305,6.9091.059,2.4872-.4967,4.9506-1.618,7.1715-1.0836,2.0455-2.6434,3.8003-4.5478,5.1162-2.1266,1.447-4.4968,2.4987-6.9966,3.1047-2.9611.7294-6.0024,1.082-9.0518,1.0495-9.6815,0-17.8734-3.0902-24.5755-9.2705l2.3614-3.5857c2.725,2.8099,5.9999,5.0279,9.6203,6.5156,4.0505,1.6547,8.3939,2.4728,12.7688,2.4051,5.4223,0,9.664-.9912,12.725-2.9735,3.061-1.9824,4.5915-4.9851,4.5915-9.0081.056-1.812-.3663-3.6068-1.2244-5.2037-.8954-1.5113-2.14-2.7858-3.6295-3.7169-1.8912-1.1801-3.9367-2.0925-6.0783-2.7112-2.4488-.755-5.3058-1.4839-8.5708-2.1864-3.3234-.6997-6.2532-1.443-8.7894-2.2302-2.267-.6607-4.4199-1.6634-6.3844-2.9735-1.6349-1.0995-2.972-2.5868-3.8919-4.3291-.8746-1.6908-1.3119-3.819-1.3119-6.3844-.0514-2.5706.5029-5.1172,1.618-7.4339,1.0692-2.1414,2.6125-4.0108,4.5128-5.4661,2.0652-1.556,4.4111-2.6993,6.9091-3.3671,2.9072-.7868,5.909-1.1694,8.9207-1.1369,3.6649-.0607,7.3102.5468,10.7572,1.7929,3.1965,1.225,6.112,3.0843,8.5708,5.4661l-2.2826,3.4983Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1730.0868,170.6513v-62.0947h4.4603v62.0947h-4.4603Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1806.9618,170.6513v-53.6988l-24.488,41.892h-2.7986l-24.488-41.892v53.6988h-4.4603v-62.0947h4.4603l25.8961,44.4283,25.8874-44.4283h4.4603v62.0947h-4.4691Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "1452.6811 170.4371 1481.1047 108.7797 1509.091 170.4371 1480.6674 150.3219 1452.6811 170.4371"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventType1);
export default __webpack_public_path__ + "static/media/eventType1.22c808e2fc46fd24460d1250342e0381.svg";
export { ForwardRef as ReactComponent };